/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_DescriptionInputs */

const en_candidate_profile_description = /** @type {(inputs: Candidate_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill out your profile to find the best job matches.`)
};

const de_candidate_profile_description = /** @type {(inputs: Candidate_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füllen Sie Ihr Profil aus, um die besten Job-Übereinstimmungen zu finden.`)
};

/**
* | output |
* | --- |
* | "Fill out your profile to find the best job matches." |
*
* @param {Candidate_Profile_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_description = /** @type {((inputs?: Candidate_Profile_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_description(inputs)
	return en_candidate_profile_description(inputs)
});